import Vuex from "vuex";

import NavegacaoTelas from "@/store/NavegacaoTelas.js";
import DadosFixos from "@/store/DadosFixos.js";
import Erros from "@/store/Erros.js";
import Usuario from "@/store/Usuario.js";
import Entidades from "@/store/Entidades.js";

// eslint-disable-next-line import/no-named-as-default-member
const store = new Vuex.Store({
	modules: {
		navegacaoTelas: NavegacaoTelas,
		dadosFixos: DadosFixos,
		usuario: Usuario,
		erros: Erros,
		entidades: Entidades,
	},
});

export default store;
